export const initialMenuGroupState = {
    dataMenuGroup: null,
    loading: false,
    error: null,
};
